module.exports = __webpack_public_path__ + "static/img/NO@2x.ad111a74.jpg";